<template>
  <div>
    <div class="bj">
      <div class="content">
        <div class="headImg"></div>
        <div class="headBox">
          <div class="name">
            <div v-if="info.censoring == 3 || info.censoring == -1">
              面试{{ info.censoring == 3 ? "已同意" : "已拒绝" }}
            </div>
            <div v-if="info.censoring == 1 || info.censoring == 2">
              {{ info.pd == 1 ? "面试未同意" : "面试已超时" }}
            </div>
          </div>
          <div class="iconfont icon-close close" @click="delClick"></div>
        </div>
        <div class="peoBox">
          <div class="img" @click.stop="jump(info.member_id)">
            <img :src="$imgUrl + info.member.avatars" alt="" />
          </div>
          <div class="name" @click.stop="jump(info.member_id)">{{ info.member.member_info.realname }}</div>
        </div>
        <div class="contBox">
          <div class="cont">
            <div class="name">时间</div>
            <div class="text">{{ info.start_time }}</div>
          </div>
          <div class="cont" v-if="info.job_id">
            <div class="name">职位</div>
            <div class="text">{{ info.jobs_name }}</div>
          </div>
          <div class="cont" v-if="info.odd_id">
            <div class="name">零工</div>
            <div class="text">{{ info.odds_name }}</div>
          </div>
          <div class="cont">
            <div class="name">联系方式</div>
            <div class="text">{{ info.member.member_info.phone }}</div>
          </div>
          <div class="cont">
            <div class="name">面试地址</div>
            <div class="text">{{ info.address }}</div>
          </div>
        </div>
        <div class="tsBox">
          <div class="box">
            <div class="iconfont icon-guzhangtousu guzhangtousu"></div>
            <div class="name">若对方面试爽约，你可进行投诉</div>
            <div class="ts" @click="tsJump">爽约投诉</div>
          </div>
        </div>
        <div
          class="btnBox"
          v-if="
            (info.censoring == 1 && !infoMember.company_id) ||
            (info.censoring == 2 && infoMember.company_id && info.pd == 1)
          "
        >
          <div class="box dis-cent" @click="jjConfirm">拒绝面试</div>
          <div class="box dis-cent" @click="tyConfirm">同意面试</div>
        </div>
      </div>
    </div>
    <Jianli :id="peoId" v-if="jlShow" @show="jlShowJs" />
  </div>
</template>

<script>
import Jianli from "./jianli.vue";

export default {
  components: {
    Jianli,
  },
  name: "",
  data() {
    return {
      peoId: "",
      jlShow: false,
      info: {
        member: {
          member_info: {},
        },
      },
      infoMember: {},
    };
  },
  props: ["id"],
  created() {
    this.get();
  },
  methods: {
    jlShowJs() {
      this.jlShow = false;
      this.canScroll();
    },
    jump(id) {
      console.log(id);
      
      this.peoId = id;
      this.jlShow = true;
      this.stopScroll();
    },
    //禁止滚动
    stopScroll() {
      var mo = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = "hidden";
      document.addEventListener("touchmove", mo, false); //禁止页面滑动
    },
    /***取消滑动限制***/
    canScroll() {
      var mo = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = ""; //出现滚动条
      document.removeEventListener("touchmove", mo, false);
    },
    tsJump() {
      let utype = window.localStorage.getItem("utype");
      // this.$router.push({
      //   path: "/fankui",
      //   query: {
      //     type: utype == 2 ? "company" : "interview",
      //     id: utype == 2 ? this.info.company_member_id : this.info.member_id,
      //   },
      // });
      let type = utype == 2 ? "company" : "interview"
      let id = utype == 2 ? this.info.company_member_id : this.info.member_id
      window.open("#/fankui?type=" + type + "&id=" + id);
    },
    get() {
      this.$get("/nozzle/web/interview_get", {
        id: this.id,
      }).then((res) => {
        console.log(res.data);
        if (res.data) {
          res.data.pd = this.timeDb(res.data.start_time);
          res.data.start_time = this.$moment(res.data.start_time).format(
            "YYYY年MM月DD日 HH:mm"
          );
          this.info = res.data;
          let member = window.localStorage.getItem("member");
          member = JSON.parse(member);
          this.infoMember = member;
        }
      });
    },
    timeDb(time2) {
      // 创建两个时间对象
      const time1 = this.$moment();
      time2 = this.$moment(time2);
      // 比较时间
      let pd = 0;
      if (time1.isBefore(time2)) {
        pd = 1;
      } else if (time1.isAfter(time2)) {
        pd = 2;
      } else {
        pd = 3;
      }
      return pd;
    },
    jjConfirm() {
      this.$post("/nozzle/web/interview_refuse", {
        id: this.id,
      }).then((res) => {
        console.log(res);
        if (res.data.status == 1) {
          this.$message.success("已拒绝该面试申请");
          this.get();
        }
      });
    },
    tyConfirm(item) {
      this.$post("/nozzle/web/interview_agree", {
        id: this.id,
      }).then((res) => {
        console.log(res);
        if (res.data.status == 1) {
          this.$message.success("已同意该面试申请");
          this.get();
        }
      });
    },
    delClick() {
      this.$emit("show");
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
.bj {
  display: flex;
  align-items: center;
  justify-content: center;
  .content {
    width: 600px;
    border-radius: 15px;
    background-color: #fff;
    position: relative;
    overflow: hidden;
    padding: 28px;
    .headImg {
      position: absolute;
      top: 0;
      right: 0;
      width: 100%;
      height: 200px;
      background: linear-gradient(
        185deg,
        #d5ebff,
        rgba(255, 255, 255, 0),
        rgba(255, 255, 255, 0)
      );
      z-index: 1;
    }
    .headBox {
      display: flex;
      justify-content: space-between;
      position: relative;
      z-index: 2;
      .name {
        font-weight: 600;
        font-size: 20px;
        color: #000;
      }
      .close {
        font-size: 20px;
        font-weight: 600;
        position: relative;
        top: -5px;
        cursor: pointer;
      }
    }
    .peoBox {
      display: flex;
      align-items: center;
      margin-top: 15px;
      position: relative;
      z-index: 99;
      .img {
        cursor: pointer;
        width: 40px;
        height: 40px;
        border-radius: 50%;
      }
      .name {
        cursor: pointer;
        font-weight: 600;
        font-size: 16px;
        margin-left: 10px;
        color: #188af5;
      }
    }
    .contBox {
      padding-top: 30px;
      .cont {
        display: flex;
        align-items: center;
        font-size: 16px;
        margin-bottom: 15px;
        .name {
          color: #86898b;
          width: 90px;
        }
        .text {
          color: #333;
          width: calc(100% - 90px);
        }
      }
    }
    .tsBox {
      height: 35px;
      display: flex;
      .box {
        background-color: #fceee3;
        display: flex;
        align-items: center;
        padding: 0 10px;
        border-radius: 5px;
        color: #f5700b;
        .guzhangtousu {
          font-size: 20px;
          margin-right: 8px;
        }
        .name {
          margin-right: 3px;
        }
        .ts {
          text-decoration: underline;
          margin-left: 15px;
          color: #188af5;
          cursor: pointer;
        }
      }
    }
    .btnBox {
      display: flex;
      justify-content: flex-end;
      margin-top: 20px;
      .box {
        border-radius: 5px;
        border: 1.5px solid #188af5;
        color: #188af5;
        height: 45px;
        margin-left: 15px;
        padding: 0 20px;
        font-weight: 500;
        font-size: 16px;
        cursor: pointer;
      }
      .box:last-child {
        background-color: #188af5;
        color: #fff;
      }
    }
  }
}
</style>
